
<!-- <div class="icons">
    <div class="header-blue">
        <nav class="navbar navbar-light navbar-expand-md navigation-clean-search">
            <div class="container-fluid"><a class="navbar-brand" routerLink="#">خيركم</a><button data-toggle="collapse" class="navbar-toggler" data-target="#navcol-1"><span class="sr-only">Toggle navigation</span><span class="navbar-toggler-icon"></span></button>
                <div class="auth-items collapse navbar-collapse" id="navcol-1">
                    <div class="items">
                        <ul class="nav navbar-nav">
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="/home">الرئيسية</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="/GetAllCateogries">الأقسام</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="/course/">الدورات التدريبية</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="/users">users</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="/addCourse">addCourse</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="/AddCategory">AddCategory</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="/GetAllCateogries">GetAllCategories</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="profile/6094176a69847e3280cb3f46">noor Profile</a></li>
                          <li class="nav-item" role="presentation"><a class="nav-link" routerLink="profile/edit/609ad62d551ca8002dc8f143">edit noor Profile</a></li> 
                      </ul>
                    </div>
                    
                    <div class="auth">
                      <span class="navbar-text"><a class="login" routerLink="register">تسجيل الدخول</a></span>
                      <a  class="btn btn-light action-button" role="button" routerLink="login">الدخول</a>
                      <a *ngIf='currentUserName!= "0000" 'class="btn btn-light action-button" role="button"(click)="logout()">logout</a>
                    </div>
               
                </div>
            </div>
        </nav>
    </div>
</div> -->


<div class="container-xxl">
 <!-- START NAVBAR -->
 <nav class="navbar navbar-expand-lg navbar-light">
  <div class="container">
    <a class="title navbar-brand" href="#"><h1><span class="logo">خَيْرُ</span>كُمْ</h1></a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link line" href="#home"  routerLink="/home">الرئيسية <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link line" href="#category" routerLink="/getAllCategories">الأقسام <span class="sr-only">(current)</span></a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link line" href="#course" routerLink="/getAllCourses/">الدورات التدريبية <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link line" on-click="scrollFn('contact')">تواصل معانا<span class="sr-only">(current)</span></a>
        </li>                   
      </ul>
      
      <form class="form-inline my-2 my-lg-0">                         
        <button class="button-style btn my-2 my-sm-0" type="submit" routerLink="/register" *ngIf="currentUserName=='0000'">إنشاء حساب</button>&nbsp; &nbsp;
        <button class="button-style btn my-2 my-sm-0" type="submit" routerLink="/login" *ngIf="currentUserName=='0000'">تسجيل الدخول</button>        
      </form>

      <div class="user" *ngIf="!(currentUserName=='0000')">
        <ul class="navbar-nav user ml-auto ml-md-0">         

           <li class="notification nav-item dropdown" style="cursor: pointer;">
            <a class="nav-link" id="navbardrop" data-toggle="dropdown">
             <p style="color: #FFAD05;" class=" badge badge-pill badge-outline-info">{{unReadNotifications}}</p> 
             <i class="bell fas fa-bell"></i>
            </a>
            <div class="dropdown-menu">
              <div class="noti">
                <p> الاشعارات</p>
                <hr>
              </div>
              <a class="dropdown-item" *ngFor="let n of userNotifications">
                <p class="row d-flex justify-content-between align-items-center" (click)="notificationRead(n._id,n)">
                  <b  (click)="notificationRead(n._id,n)" [ngClass]="{'text-warning' : !n.isRead}">{{n.message}}</b>
                  <i class="fas fa-times text-danger" (click)="deleteNotification(n._id) "></i>                                                                                                          
                </p>
              </a>
            </div>
           </li>
          
          <li class="nav-item dropdown">
              <a class="nav-link" id="userDropdown" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img class="img-fluid rounded-circle" src="https://khairokom-uploadfiles.azurewebsites.net/files/{{user.img}}" style="max-width: 40px; min-width: 40px; min-height: 40px; max-height: 40px;">
              </a>
              <div class="dropdown-menu dropdown-menu-left text-center" aria-labelledby="userDropdown" >       
                  <a class="dropdown-item" routerLink="/profile/{{userId}}" ><b>{{userName}}</b></a>                  
                  <a class="dropdown-item" routerLink="/myCourses/{{userId}}">دوراتي التدريبية</a>                  
                  <a class="dropdown-item" routerLink="/updateUser/{{userId}}">تعديل حسابي</a>
                  <a class="dropdown-item" routerLink="/admin" class="text-primary " *ngIf="isAdmin==true"> لوحة التحكم (خاصة بالمدير)</a>
                  
                  <a class="dropdown-item" (click)="logout()" style="cursor: pointer;">تسجيل الخروج</a>                  
              </div>
          </li>          
        </ul>
      </div>
    </div>
  </div>
</nav>
<!-- END NAVBAR -->
</div>